// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"596":"404","773":"welcome"}[chunkId] + "." + {"596":"23803f96","773":"3b77581f"}[chunkId] + ".js";
};